/* Asset: djuce-progress-bar.js */
class DjuceProgressBar extends HTMLElement {
  constructor() {
    super();
    this.cartCount = 0;
    
    try {
      const localesScript = this.querySelector('.dpb-locales-json');
      this.locales = JSON.parse(localesScript.textContent);
    } catch (e) {
      console.error("DPB: Failed to parse locales.");
      this.locales = { 
        progress_1: "1 item left to Free shipping + 10% off order", 
        progress_2: "1 item left to 20% off order", 
        progress_3: "Max Discount Unlocked!" 
      };
    }
  }

  async connectedCallback() {
    this.render();
    await this.fetchCartState();
    
    this.ampUpdateHandler = this.handleAmpCartUpdate.bind(this);
    window.addEventListener('djuce:cart:updated', this.ampUpdateHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('djuce:cart:updated', this.ampUpdateHandler);
  }

  async fetchCartState() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (response.ok) {
        const cart = await response.json();
        this.cartCount = cart.item_count || 0;
        this.render();
      }
    } catch (error) {
      console.warn('DPB: Cart fetch failed.');
    }
  }

  handleAmpCartUpdate(event) {
    const cart = event.detail;
    if (cart && typeof cart.item_count !== 'undefined') {
      this.cartCount = cart.item_count;
      this.render();
    }
  }

  render() {
    // Hide if empty
    if (this.cartCount === 0) {
      this.style.display = 'none';
      return;
    } else {
      this.style.display = 'block';
    }

    // 1. Update the Text
    const textEl = this.querySelector('.dpb-status-text');
    if (textEl) {
      if (this.cartCount === 1) textEl.innerHTML = this.locales.progress_1;
      else if (this.cartCount === 2) textEl.innerHTML = this.locales.progress_2;
      else textEl.innerHTML = `<strong>${this.locales.progress_3}</strong>`;
    }

    // 2. Update the Fill Width
    const fillEl = this.querySelector('.dpb-fill');
    const progressCount = Math.min(this.cartCount, 3);
    if(progressCount == 1){
      if (fillEl) fillEl.style.width = `25%`;
    }else if(progressCount == 2){
      if (fillEl) fillEl.style.width = `50%`;
    }else{
      if (fillEl) fillEl.style.width = `${(progressCount / 3) * 100}%`;
    }

    // 3. Update the Nodes and Labels (Green states)
    const node2 = this.querySelector('.dpb-node-2');
    const label2 = this.querySelector('.dpb-label-2');
    const node3 = this.querySelector('.dpb-node-3');
    const label3 = this.querySelector('.dpb-label-3');

    if (this.cartCount >= 2) {
      node2?.classList.add('reached');
      label2?.classList.add('reached');
    } else {
      node2?.classList.remove('reached');
      label2?.classList.remove('reached');
    }

    if (this.cartCount >= 3) {
      node3?.classList.add('reached');
      label3?.classList.add('reached');
    } else {
      node3?.classList.remove('reached');
      label3?.classList.remove('reached');
    }
    
    const headerEl = this.querySelector('.dpb-header');
    if (this.cartCount >= 3) {
      headerEl?.classList.add('dpb-header--maxed');
    } else {
      headerEl?.classList.remove('dpb-header--maxed');
    }


  }
}

if (!customElements.get('djuce-progress-bar')) {
  customElements.define('djuce-progress-bar', DjuceProgressBar);
}
